import Styles from './statistics.module.css';
import React from 'react';
import { Icon } from '@weezevent/nacre';

export default function StatisticsMoreLabel({ children }) {
    return (
        <div className={Styles['statistics-more-label-container']}>
            <span className={Styles['statistics-more-label']}>{children}</span>
            <Icon name={'chevron-right'} size={'small'} />
        </div>
    );
}

export function CreditsStatisticsFooter({ children }) {
    return <div className={Styles['statistics-footer']}>{children}</div>;
}
